<div class="bc-search-results-panel bc-panel">
  <div class="bc-panel-header">
    <svg-icon class="bc-panel-header-back-icon"
              icon="arrow-left"
              (click)="backToFilters()"
              [attr.data-automation-id]="'bc-back-to-filters'"></svg-icon>
    <span class="bc-panel-header-text">
      <span class="bc-search-ellipsis" [attr.data-automation-id]="'bc-search-results'">{{ searchObject.results.length }}
        <span>{{ 'bcSearchResultsPanel.resultsFoundFor' | translate }}</span>'
        <span [attr.title]="searchObject.query">{{ searchObject.query }}</span>
      </span>'
    </span>
  </div>

  <div class="bc-search-item-list" *ngIf="searchObject.hasResults">
    <div *ngFor="let result of searchObject.results"
         class="search-item"
         [attr.data-automation-id]="'bc-search-item'">
      <div class="search-content js-expand-search-details" (click)="openWorkItem(result)" [attr.data-workitem-id]="result.id">
        <div class="search-item-icon">
          <svg-icon icon="chat-large" *ngIf="result.isChat()" [attr.data-automation-id]="'bc-search-chat-result-icon'"></svg-icon>
          <svg-icon icon="mail" *ngIf="result.isEmail()" [attr.data-automation-id]="'bc-search-email-result-icon'"></svg-icon>
          <svg-icon icon="sms" *ngIf="result.isSms()"></svg-icon>
          <svg-icon icon="message" *ngIf="result.isFacebook()"></svg-icon>
          <svg-icon icon="async-message" *ngIf="result.isAsyncMessage()"></svg-icon>
          <span class="message-count" *ngIf="result.messageCount > 1">{{ result.messageCount }}</span>
        </div>

        <div class="search-item-content">
          <p class="truncated bc-timestamp">
            <span *ngIf="result.isEmail() || result.isSms() || result.isFacebook() || result.isAsyncMessage()">
              <span *ngIf="result.Name">{{ result.Name }} | </span>
            </span>
            <span *ngIf="result.isChat()">
              <span *ngIf="!result.Name">{{ 'bcSearchResultsPanel.chatWithVisitor' | translate }}</span>
              <span *ngIf="result.Name">{{ result.Name }}</span>
              <span> | </span>
            </span>
            <span>{{ getFormattedDateProperty(result.Created) }}</span>
          </p>
          <p class="truncated first-line {{ result.type }}">
            {{ result.firstLine }}
          </p>

          <p class="truncated second-line {{ result.type }}">
            {{ result.secondLine }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
